var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionEyeOffFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 8c2 .1 3.6 1.7 3.7 3.7l4.1 4.1c1.8-2 2.9-3.9 2.9-3.9s-4.4-8-11-8c-1.1.1-2.2.3-3.2.7l3.5 3.4zm6.3 9.3l-3.2-3.3-3.9-3.9-1.6-1.5L3.05 2l-1.4 1.4 3.4 3.4C2.35 9.1.75 12 .75 12s4.4 8 11 8c1.9 0 3.5-.6 5-1.5l3.6 3.6 1.4-1.4-3.4-3.4zm-6.6-1.3c-2.2 0-4-1.8-4-4 0-.7.2-1.4.5-2l1.5 1.5v.5c0 1.1.9 2 2 2 .2 0 .3 0 .5-.1l1.5 1.5c-.6.4-1.3.6-2 .6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionEyeOffFill);
export default __webpack_public_path__ + "7767d13c5013d83edd1123f8d8fa1732.svg";
export { ForwardRef as ReactComponent };